document.addEventListener('DOMContentLoaded',()=>{const root=document.getElementById('bws-elevated');if(!root)return;const collage=document.getElementById('bws-recent-work');const button=document.getElementById('bws-collage-pause');const media=window.matchMedia('(prefers-reduced-motion: reduce)');const pausedLabel=button?.dataset.playLabel;const playingLabel=button?.dataset.pauseLabel;function pause(paused){root.dataset.motion=String(!paused);if(!collage||!button)return;collage.dataset.paused=String(paused);button.setAttribute('aria-pressed',String(paused));button.textContent=paused?pausedLabel:playingLabel;}pause(media.matches);if(button)button.addEventListener('click',()=>{const paused=collage.dataset.paused!=='true';collage.dataset.allowMotion=String(!paused);pause(paused)});media.addEventListener('change',e=>{if(e.matches){if(collage)collage.dataset.allowMotion='false';pause(true)}});if(collage){const count=collage.querySelector('.collage-group').children.length;document.getElementById('bws-collage-track').style.animationDuration=Math.max(45,count*10)+'s';}});
(() => {
  let loader;
  function loadInstagram() {
    if (window.instgrm?.Embeds?.process) return Promise.resolve();
    if (loader) return loader;
    loader = new Promise((resolve, reject) => {
      let script = document.querySelector('script[src="https://www.instagram.com/embed.js"]');
      const fresh = !script;
      if (fresh) {
        script = document.createElement('script');
        script.src = 'https://www.instagram.com/embed.js';
        script.async = true;
      }
      const fail = () => {
        clearTimeout(timer);
        if (fresh) script.remove();
        reject(new Error('Instagram embed unavailable'));
      };
      const timer = setTimeout(fail, 12000);
      script.addEventListener('load', () => {
        clearTimeout(timer);
        if (window.instgrm?.Embeds?.process) resolve();
        else fail();
      }, {once: true});
      script.addEventListener('error', fail, {once: true});
      if (fresh) document.head.append(script);
    }).catch(error => { loader = undefined; throw error; });
    return loader;
  }
  function initialize(root = document) {
    root.querySelectorAll('[data-bws-instagram]').forEach(details => {
      if (details.dataset.bwsIgBound) return;
      details.dataset.bwsIgBound = 'true';
      let state = 'idle';
      let revision = 0;
      let activeObserver;
      let activeTimer;
      details.addEventListener('toggle', async () => {
        if (!details.open) {
          revision += 1;
          activeObserver?.disconnect();
          clearTimeout(activeTimer);
          details.querySelector('[data-bws-ig-slot]').replaceChildren();
          state = 'idle';
          return;
        }
        if (state === 'loading' || state === 'ready') return;
        const currentRevision = ++revision;
        state = 'loading';
        const slot = details.querySelector('[data-bws-ig-slot]');
        const status = details.querySelector('[data-bws-ig-status]');
        const template = details.querySelector('[data-bws-ig-template]');
        status.hidden = false;
        status.textContent = details.dataset.loading;
        slot.replaceChildren(template.content.cloneNode(true));
        const quote = slot.querySelector('blockquote');
        let observer;
        let timer;
        const failed = () => {
          if (currentRevision !== revision) return;
          state = 'error';
          status.textContent = details.dataset.error;
          status.hidden = false;
          observer?.disconnect();
          clearTimeout(timer);
        };
        try {
          const url = new URL(quote.dataset.instgrmPermalink);
          if (!['www.instagram.com', 'instagram.com'].includes(url.hostname) || url.protocol !== 'https:' || !/^\/(reel|p)\/[A-Za-z0-9_-]+\/$/.test(url.pathname)) throw new Error('Invalid Instagram URL');
          const check = () => {
            if (currentRevision !== revision) return;
            const frame = slot.querySelector('iframe');
            if (!frame) return;
            state = 'ready';
            status.hidden = true;
            observer?.disconnect();
            clearTimeout(timer);
          };
          observer = new MutationObserver(check);
          activeObserver = observer;
          observer.observe(slot, {childList: true, subtree: true});
          await loadInstagram();
          if (currentRevision !== revision) return;
          window.instgrm.Embeds.process();
          check();
          if (state !== 'ready') {
            timer = setTimeout(failed, 12000);
            activeTimer = timer;
          }
        } catch { failed(); }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

(() => {
  function bindCartCount() {
    const headerCount = document.querySelector('.nav-links [data-bws-cart-count]');
    if (!headerCount) return;
    let refreshTimer;
    async function refresh() {
      try {
        const response = await fetch(headerCount.dataset.cartUrl, {headers: {'Accept': 'application/json'}});
        if (!response.ok) return;
        const cart = await response.json();
        if (Number.isInteger(cart.item_count)) headerCount.textContent = String(cart.item_count);
      } catch {}
    }
    const popupCount = document.querySelector('[data-cart-popup-cart-quantity]');
    if (popupCount) new MutationObserver(() => {
      const count = popupCount.textContent.trim();
      if (/^\d+$/.test(count)) headerCount.textContent = count;
    }).observe(popupCount, {childList: true, characterData: true, subtree: true});
    if (location.pathname.replace(/\/$/, '').endsWith('/cart')) {
      const main = document.getElementById('MainContent');
      if (main) new MutationObserver(() => {
        clearTimeout(refreshTimer);
        refreshTimer = setTimeout(refresh, 150);
      }).observe(main, {childList: true, subtree: true});
    }
    window.addEventListener('pageshow', refresh);
    document.addEventListener('cart:updated', refresh);
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindCartCount);
  else bindCartCount();
})();
